import * as React from 'react'

function SvgWarningFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.334 22.966L13.29 4.833c.778-1.287 2.646-1.287 3.424 0l10.955 18.133c.805 1.333-.155 3.034-1.712 3.034H4.046c-1.557 0-2.517-1.701-1.712-3.034zM13.001 15v-4a2 2 0 114 0v4a2 2 0 01-4 0zm4 6a2 2 0 11-4 0 2 2 0 014 0z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgWarningFilled
